import { render, staticRenderFns } from "./remind.vue?vue&type=template&id=217fe346&scoped=true&"
import script from "./remind.vue?vue&type=script&lang=js&"
export * from "./remind.vue?vue&type=script&lang=js&"
import style0 from "./remind.vue?vue&type=style&index=0&lang=css&"
import style1 from "./remind.vue?vue&type=style&index=1&id=217fe346&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217fe346",
  null
  
)

export default component.exports